import { Multimedia } from '@web/shared/module/multimedia';
import { OrderItemRefundSummary, ProductType } from '@web/shared/module/shop';
import { Guid, Nillable } from '@web/utils';

export class AdminOrderRefundDataItem {
  public constructor(
    private readonly data: {
      id: Guid;
      name: string;
      subName?: Nillable<string>;
      type: ProductType;
      quantity: number;
      unitPrice: number;
      price: number;
      slug?: Nillable<string>;
      featuredFile?: Nillable<Multimedia>;
      refundSummary?: Nillable<OrderItemRefundSummary>;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get name(): string {
    return this.data.name;
  }

  public get subName(): Nillable<string> {
    return this.data.subName;
  }

  public get type(): ProductType {
    return this.data.type;
  }

  public get quantity(): number {
    return this.data.quantity;
  }

  public get unitPrice(): number {
    return this.data.unitPrice;
  }

  public get price(): number {
    return this.data.price;
  }

  public get slug(): Nillable<string> {
    return this.data.slug;
  }

  public get featuredFile(): Nillable<Multimedia> {
    return this.data.featuredFile;
  }

  public get refundSummary(): Nillable<OrderItemRefundSummary> {
    return this.data.refundSummary;
  }
}
